import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';
import createPersistedState from 'vuex-persistedstate';


// 1.安装插件
Vue.use(Vuex)
// 2.state对象
const state = {
  token: '',
  carCount: 0,
  goodsInfo: '',
  carInfo: '',
  modeType: '', // 1: 普通 2: 积分 3: 福利
  goodsId: '',
  orderInfo: {},
  personType: 0,
  saveOrderType: '',
  orderId: '',
  refundInfo: '',
  afterSaleId: '',
  afterSaleGoodsId: '',
  columnId: '',
  columnClassId: '',
  columnTitle: "",
  categoryId: '',
  categoryTitle: '',
  recommendType: '',
  brandId: '',
  messageType: '',
  activityId: '',
  activityGroupId: '',
  activityTitle: '',
  jdGoodsType: 1,//1：普通商品 2：京东商品
  rechargeMoney: 0,
  pickUpAddress: '',//取件地址
  shippingAddress: '',//收货地址
  jdGoodsInfo: '',//京东商品列表信息
  webGoodsInfo: '',//平台商品列表信息,
  cakeCityId: '',//蛋糕专区城市id
  cakeCityName: '',//蛋糕专区城市名字
  cakeCityLocation: {},//蛋糕专区经纬度
  cakeGoodsInfo: '',//蛋糕商品信息
  cakeParams: '',
  deliveryRuleInfo: {},//配送规则信息
  cakeBrandInfo: {},//蛋糕品牌信息
  cakeBrandGoodsInfo: '',//品牌列表信息
  cakeShopInfo: {},//蛋糕门店信息
  cakeShopGoodsInfo: '',//蛋糕门店商品信息
  floatStatus: true,//飘窗状态
  layoutId: '',//首页分组布局id
  specialInfo: '',//限量特惠搜索信息
  seckillInfo: '',//限时秒杀搜索信息
  movieCityId: '',//电影城市id
  movieCityName: '',//电影城市名字
  movieInfo: {},
  couponInfo: '',//卡券列表删选信息
  commentGoodsInfo: {},//评价商品信息

  // 平台背景风格
  navBack: '#e8e8e8',//#e8e8e8
  startColor: '#ffffff',
  endColor: '#ffffff',
  backColors: 'background: linear-gradient( 180deg, #ffffff 0%, #ffffff 100%);',//#ffffff
  fontsColor: '#000000',//#000000
  txtColor: '#999999',//#999999
  checkColor: '#004098',
  themeColor: '',//主题颜色
}
// 3.store对象
const store = new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [createPersistedState({
    storage: window.sessionStorage, // 或者 localStorage
  })]
})

export default store